import { render, staticRenderFns } from "./SupportBanner.vue?vue&type=template&id=b4a5fc74&scoped=true&"
import script from "./SupportBanner.vue?vue&type=script&lang=js&"
export * from "./SupportBanner.vue?vue&type=script&lang=js&"
import style0 from "./SupportBanner.vue?vue&type=style&index=0&id=b4a5fc74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5fc74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsLogoEmblem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/LogoEmblem.vue').default})
